import { QR_STATE_CODES } from '@yoti/ui-kit-components-react/qr-code'
import * as SHARE_STATUS from '../../constants/shareStatus'

const shareStatusToQrStateMapping = {
  [SHARE_STATUS.ACCEPTED]: QR_STATE_CODES.WAITING,
  [SHARE_STATUS.COMPLETED]: QR_STATE_CODES.ACCEPTED,
  [SHARE_STATUS.TIMED_OUT]: QR_STATE_CODES.EXPIRED,
  [SHARE_STATUS.REJECTED]: QR_STATE_CODES.ERROR,
  [SHARE_STATUS.FAILED]: QR_STATE_CODES.ERROR,
}

const getCurrentState = (shareStatus, hasError) => {
  if (hasError) {
    return QR_STATE_CODES.ERROR
  }
  return shareStatusToQrStateMapping[shareStatus] || QR_STATE_CODES.LOADING
}

export default getCurrentState
